import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-616999ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "key-field" }
const _hoisted_2 = {
  key: 1,
  class: "value-field"
}

import { format } from 'date-fns'
import yaml from 'js-yaml'
import { ConfigProperty } from './config'
import { PolicySchema } from '@/generated/sdk'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PolicyConfigurationSettingsTable',
  props: {
    policyConfig: {},
    settingsConfig: {},
    editMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const tableData = computed(() => {
  const result = []
  for (const key in props.policyConfig) {
    // hide properties with null values except for applications
    if (props.policyConfig[key] == null && key !== 'applications') continue
    result.push({
      key,
      value: props.policyConfig[key],
      type: props.settingsConfig.find(p => p.id === key)?.type ?? null,
    })
  }
  return result
})

function formatValue(key: string, value: any, type: string): string {
  if (type === 'date') return format(new Date(value), 'dd-MM-yy HH:mm:ss')
  if (type === 'id') return value.split('/')[3]
  if (type === 'boolean') return value === true ? 'Yes' : 'No'
  if (type === 'json' || type === 'multiselect') return yaml.dump(value)

  return value
}

function formatKey(key: string) {
  const result = key.replace(/([A-Z])/g, ' $1')
  return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase()
}

return (_ctx: any,_cache: any) => {
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_PolicyConfigurationApplications = _resolveComponent("PolicyConfigurationApplications")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: tableData.value,
    class: "table-padding",
    "selection-mode": "single"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_PrimeColumn, {
        field: "key",
        "header-style": "display:none;",
        style: {"width":"30%","vertical-align":"baseline","background-color":"#f9f9f9"}
      }, {
        body: _withCtx(({ data: { key } }) => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(formatKey(key)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_PrimeColumn, {
        field: "value",
        style: {"width":"70%"},
        "header-style": "display:none;"
      }, {
        body: _withCtx(({ data: { key, value, type } }) => [
          (key === 'applications')
            ? (_openBlock(), _createBlock(_component_PolicyConfigurationApplications, {
                key: 0,
                "application-list": value,
                "edit-mode": _ctx.editMode
              }, null, 8, ["application-list", "edit-mode"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(formatValue(key, value, type)), 1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})